export const OPERATION_WIDTHS = [20, 20, 20, 20, 15, 5]; // margin right

export const OPERATION_HEADER_COLUMNS = [
  { text: 'Тип', width: OPERATION_WIDTHS[0] },
  { text: 'Админ', width: OPERATION_WIDTHS[1] },
  { text: 'Время запуска', width: OPERATION_WIDTHS[2] },
  { text: 'Время завершения', width: OPERATION_WIDTHS[3] },
  { text: 'Статус', width: OPERATION_WIDTHS[4] },
  { text: '', width: OPERATION_WIDTHS[5] },
];

